'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Util = require('./Util');

Object.defineProperty(exports, 'toCodePoints', {
  enumerable: true,
  get: function get() {
    return _Util.toCodePoints;
  }
});
Object.defineProperty(exports, 'fromCodePoint', {
  enumerable: true,
  get: function get() {
    return _Util.fromCodePoint;
  }
});

var _LineBreak = require('./LineBreak');

Object.defineProperty(exports, 'LineBreaker', {
  enumerable: true,
  get: function get() {
    return _LineBreak.LineBreaker;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/css-line-break/dist/index.js
// module id = 1088
// module chunks = 0